import { useEffect, useRef, useState } from "react";
import IconClose from "assets/svgs/close-button.svg";
import IconEmail from "assets/svgs/email-outline.svg";
import Nav from "./Nav";
import BottomInfo from "@components/contributeCase/BottomInfo";
import CaseUpdates from "@components/contributeCase/caseUpdates";
import AddSource from "@components/contributeCase/addSources";
import useAnalytics from "hooks/useAnalytics";

export default function ContributePanel({
  panelVisible,
  setPanelVisible,
  outsetaUserId,
  slug,
  source,
}) {
  const [tab, setTab] = useState("Add Source");
  const [sourceSteps, setSourceSteps] = useState("addSource");
  const panel = useRef();
  const {track} = useAnalytics();

  useEffect(() => {
    if (!panelVisible) return;
    panel.current.classList.remove("translate-x-full");
    document.body.classList.add("contribute-panel-on");
    track("contribute_panel_opened", {
      slug: slug,
      source: source,
    });
  }, [panelVisible]);

  const handleClose = () => {
    panel.current.classList.add("translate-x-full");
    document.body.classList.remove("contribute-panel-on");
    setTimeout(() => {
      setPanelVisible(false);
    }, 310);
  };
  return (
    <div
      className="bg-white fixed top-0 bottom-0 right-0 h-full sm:w-98 w-full shadow-md z-100 overflow-auto text-black transition duration-300 transform translate-x-full py-10"
      ref={panel}
    >
      <button
        className="absolute top-4 left-7 hover:scale-110 transition"
        type="button"
        onClick={handleClose}
      >
        <IconClose width="15" />
      </button>
      <div className="min-h-full flex flex-col">
        {sourceSteps === "addSource" && <Nav tab={tab} setTab={setTab} />}
        <div className="py-10 px-7">
          {tab === "Case Updates" ? (
            <CaseUpdates setTab={setTab} outsetaUserId={outsetaUserId} />
          ) : (
            <AddSource
              setSourceSteps={setSourceSteps}
              sourceSteps={sourceSteps}
              outsetaUserId={outsetaUserId}
              slug={slug}
            />
          )}
        </div>
        {tab === "Add Source" && sourceSteps === "addSource" ? (
          <BottomInfo />
        ) : null}
        {tab === "Add Source" && sourceSteps === "addSource" ? (
          <div className="border-t pt-5 border-gray-200 mx-7 mt-auto">
            <a
              className="flex items-center hover:underline"
              href="mailto:caseresearch@uncovered.com"
            >
              <IconEmail width="20" />
              <span className="ml-2">Contact Us</span>
            </a>
          </div>
        ) : null}
      </div>
    </div>
  );
}
